/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable max-len */
import { Form, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import UploadComponent, { IFileList } from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import prehledUzivateluApi, { ISezUzivatelu } from 'services/spravaUzivatelu/prehled';
import {
    EStavUzivatele,
    ICertKontrolaResp,
    IUzivatelDetail,
    certKontrolaApi,
    uzivatelEditApi
} from 'services/spravaUzivatelu/uzivatele';

import { ENotificationType } from 'enums/notificationType';
import { EProfilyTyp } from 'enums/profilyTyp';
import routePathEnum from 'enums/routePathEnum';

import trueFalseSelect from 'data/codebooks/trueFalseSelect';

import emailValidation from 'utils/validations/emailValidation';
import phoneValidation from 'utils/validations/phoneValidation';

interface IUzivatel {
    selectedUser?: IUzivatelDetail;
    setSelectedUser?: React.Dispatch<React.SetStateAction<IUzivatelDetail | undefined>>;
    prehledData?: ISezUzivatelu;
}

const Uzivatel: React.FC<IUzivatel> = ({ selectedUser, setSelectedUser, prehledData }) => {
    const [form] = Form.useForm();
    const { NotificationComponent, aktivniFirma } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const [certUploadResp, setCertUploadResp] = useState<ICertKontrolaResp>();
    const [showCertErr, setShowCertErr] = useState<boolean>(false);
    const [err, setErr] = useState<string>('');
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [, setRerender] = useState<boolean>(false);
    const [fileList, setFileList] = useState<IFileList[]>([]);
    const [prehledDataActual, setPrehledDataActual] = useState<ISezUzivatelu | undefined>(prehledData);

    useEffect(() => {
        // nacitanie dat pri zmene strany v table
        if (!prehledData) {
            setLoading(true);
            prehledUzivateluApi(0)
                .then(resp => {
                    setPrehledDataActual(resp);
                })
                .finally(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        setLoading(true);
        const dataToSend = {
            ...selectedUser,
            ...fieldsValue
        };
        delete dataToSend.dn;
        delete dataToSend.issuer;

        uzivatelEditApi({
            ...dataToSend,
            ...(dataToSend.typprihlaseni
                ? {}
                : {
                      typprihlaseni: 'CERT'
                  }),
            ...(dataToSend.vypis && {
                vypis: dataToSend.vypis === 'true'
            }),
            ...(dataToSend.upis && {
                upis: dataToSend.upis === 'true'
            }),
            ...(dataToSend.sicav && {
                sicav: dataToSend.sicav === 'true'
            }),
            ...(dataToSend.srd && {
                srd: dataToSend.srd === 'true'
            }),
            ...(dataToSend.videtvypisyost && {
                videtvypisyost: dataToSend.videtvypisyost === 'true'
            }),
            ...(dataToSend.adminuziv && {
                adminuziv: dataToSend.adminuziv === 'true'
            }),
            ...(!dataToSend.stavuctu && {
                stavuctu: EStavUzivatele.AKTIVNI
            })
        })
            .then(resp => {
                if (resp.data.code === 'CERTIFIKAT') {
                    setErr('NOVY_UCET_CERTIFIKAT');
                } else if (resp.data.code === 'DUPLICITA') {
                    setErr('NOVY_UCET_DUPLICITA');
                } else {
                    setErr('');
                    NotificationComponent({
                        description: 'USER_EDIT_SUCCESS',
                        type: ENotificationType.SUCCESS
                    });
                    navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.UZIVATELE_PREHLED}`);
                    setSelectedUser && setSelectedUser(undefined);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        form.setFieldsValue({
            typprihlaseni: selectedUser?.typprihlaseni
        });
        return () => form.resetFields();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <Title level={4} text={!selectedUser ? 'WRNOVYUZIVATEL' : 'DETAIL_UZIVATELE'} />
            <>
                <FormWrapper onFinish={onFinish} outForm={form}>
                    <>
                        <InputComponent
                            disabled={selectedUser && !isEdit}
                            label="PRIJMENI"
                            name="prijmeni"
                            maxLength={100}
                            initialValue={selectedUser?.prijmeni}
                        />
                        <InputComponent
                            disabled={selectedUser && !isEdit}
                            label="JMENO"
                            name="jmeno"
                            maxLength={100}
                            initialValue={selectedUser?.jmeno}
                        />
                        <InputComponent
                            disabled={selectedUser && !isEdit}
                            label="TELEFON"
                            name="telefon"
                            type="text"
                            maxLength={30}
                            initialValue={selectedUser?.telefon}
                            rules={phoneValidation()}
                        />
                        <InputComponent
                            disabled={selectedUser && !isEdit}
                            label="EMAIL"
                            name="email"
                            type="text"
                            maxLength={200}
                            initialValue={selectedUser?.email}
                            rules={emailValidation()}
                        />
                        {selectedUser && (
                            <>
                                <InputComponent
                                    disabled={true}
                                    label="ID_UCTU"
                                    name="id"
                                    initialValue={selectedUser.id}
                                    notRequired={true}
                                    rules={[]}
                                />
                                {selectedUser.username && (
                                    <InputComponent
                                        disabled={true}
                                        label="USERNAME"
                                        name="username"
                                        initialValue={selectedUser.username}
                                        notRequired={true}
                                    />
                                )}
                            </>
                        )}

                        {typeof prehledDataActual?.vypis === 'boolean' && (
                            <SelectComponent
                                disabled={(!isEdit && !!selectedUser) || aktivniFirma?.typ === EProfilyTyp.STATNISPRAVA}
                                name="vypis"
                                defaultValue={
                                    aktivniFirma?.typ === EProfilyTyp.STATNISPRAVA
                                        ? 'true'
                                        : typeof selectedUser?.vypis === 'boolean'
                                          ? String(selectedUser.vypis || prehledDataActual?.vypis || 'false')
                                          : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="Výpis"
                                data={trueFalseSelect}
                            />
                        )}
                        {typeof prehledDataActual?.upis === 'boolean' && (
                            <SelectComponent
                                disabled={!isEdit && !!selectedUser}
                                name="upis"
                                defaultValue={
                                    typeof selectedUser?.upis === 'boolean'
                                        ? String(selectedUser.upis || prehledDataActual?.upis || 'false')
                                        : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="Úpis"
                                data={trueFalseSelect}
                            />
                        )}
                        {typeof prehledDataActual?.sicav === 'boolean' && (
                            <SelectComponent
                                disabled={!isEdit && !!selectedUser}
                                name="sicav"
                                defaultValue={
                                    typeof selectedUser?.sicav === 'boolean'
                                        ? String(selectedUser.sicav || prehledDataActual?.sicav || 'false')
                                        : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="SICAV"
                                data={trueFalseSelect}
                            />
                        )}
                        {typeof prehledDataActual?.srd === 'boolean' && (
                            <SelectComponent
                                disabled={!isEdit && !!selectedUser}
                                name="srd"
                                defaultValue={
                                    typeof selectedUser?.srd === 'boolean'
                                        ? String(selectedUser.srd || prehledDataActual?.srd || 'false')
                                        : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="SRD"
                                data={trueFalseSelect}
                            />
                        )}

                        {typeof prehledDataActual?.videtvypisyost === 'boolean' && (
                            <SelectComponent
                                disabled={!isEdit && !!selectedUser}
                                name="videtvypisyost"
                                defaultValue={
                                    typeof selectedUser?.videtvypisyost === 'boolean'
                                        ? String(
                                              selectedUser.videtvypisyost ||
                                                  prehledDataActual?.videtvypisyost ||
                                                  'false'
                                          )
                                        : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="Právo vidět výpisy ostatních"
                                data={trueFalseSelect}
                            />
                        )}
                        {typeof prehledDataActual?.adminuziv === 'boolean' && (
                            <SelectComponent
                                disabled={!isEdit && !!selectedUser}
                                name="adminuziv"
                                defaultValue={
                                    typeof selectedUser?.adminuziv === 'boolean'
                                        ? String(selectedUser.adminuziv || prehledDataActual?.adminuziv || 'false')
                                        : 'false'
                                }
                                isFormItem={true}
                                labelParagraph="Administrátor uživatelů"
                                data={trueFalseSelect}
                            />
                        )}
                        {selectedUser && (
                            <>
                                <SelectComponent
                                    isFormItem={true}
                                    notRequired={true}
                                    disabled={!isEdit}
                                    labelParagraph="STAV_UZIVATELE"
                                    name="stavuctu"
                                    defaultValue={selectedUser.stavuctu}
                                    data={[
                                        {
                                            value: EStavUzivatele.AKTIVNI,
                                            labelcz: 'UZIVATEL_STAV_A'
                                        },
                                        {
                                            value: EStavUzivatele.NEAKTIVNI,
                                            labelcz: 'UZIVATEL_STAV_N'
                                        }
                                    ]}
                                />
                                <SelectComponent
                                    labelParagraph="AUTH_PRVEK"
                                    isFormItem={true}
                                    disabled={true}
                                    // disabled={!isEdit || selectedUser.typprihlaseni === 'CERT'}
                                    name="typprihlaseni"
                                    onChange={() => {
                                        setRerender(pv => !pv);
                                    }}
                                    defaultValue={selectedUser.typprihlaseni}
                                    data={[
                                        {
                                            labelcz: 'TYP_PRIHLASENI_CERT',
                                            value: 'CERT'
                                        },
                                        {
                                            labelcz: 'TYP_PRIHLASENI_PXKLIC',
                                            value: 'PXKLIC'
                                        }
                                    ]}
                                />
                            </>
                        )}
                        {(!selectedUser || (isEdit && form.getFieldValue('typprihlaseni') === 'CERT')) && (
                            <Form.Item
                                style={{
                                    marginTop: 16,
                                    marginBottom: 16
                                }}
                                name="tempcert"
                                label={<Paragraph text={'CERTIFIKAT'} strong={true} />}
                                extra={
                                    showCertErr && (
                                        <Paragraph text={'DUVERNE_INF_ERR_401'} className="extramessage-text" />
                                    )
                                }
                                rules={[
                                    {
                                        required: !isEdit || selectedUser?.typprihlaseni !== 'CERT',
                                        message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>
                                    }
                                ]}
                                validateTrigger="onChange"
                            >
                                <div
                                    style={{
                                        marginBottom: 22
                                    }}
                                >
                                    <UploadComponent
                                        id="uzivatelUploadBtn"
                                        showDownloadIcon={true}
                                        buttonLoading={uploading}
                                        fileList={fileList}
                                        onRemove={() => {
                                            setFileList([]);
                                            setCertUploadResp(undefined);
                                        }}
                                        accept={'.pem, .dem, .cer, .der'}
                                        buttonDisabled={fileList.length > 0}
                                        onChange={uplData => {
                                            if (uplData.event) {
                                                setUploading(true);
                                                setShowCertErr(false);
                                            }
                                            if (uplData.fileList)
                                                setFileList(
                                                    uplData.fileList
                                                        .filter(f => f.status && f.status !== 'error')
                                                        .map(e => {
                                                            return {
                                                                // oid: resp.id!,
                                                                uid: e.uid!,
                                                                name: e.name.normalize()!,
                                                                fileName: e.fileName
                                                                    ? e.fileName
                                                                    : e.response
                                                                      ? e.response.tempnazev
                                                                      : ''!,
                                                                type: e.type!,
                                                                size: e.size!,
                                                                status: e.status ? e.status : 'error'
                                                            };
                                                        })
                                                );
                                            if (uplData.file.response) {
                                                certKontrolaApi(uplData.file.response.tempnazev)
                                                    .then(data => {
                                                        if (data.message === 'OK') {
                                                            setCertUploadResp(data);
                                                            uplData.fileList.map(e => {
                                                                setFileList([
                                                                    {
                                                                        uid: e.uid,
                                                                        name: e.name.normalize(),
                                                                        fileName: e.fileName
                                                                            ? e.fileName
                                                                            : e.response
                                                                              ? e.response.tempnazev
                                                                              : '',
                                                                        type: e.type!,
                                                                        size: e.size!,
                                                                        status: e.status ? e.status : 'error'
                                                                    }
                                                                ]);
                                                                form.setFieldsValue({
                                                                    tempcert: e.response.tempnazev,
                                                                    dn: data.dn,
                                                                    issuer: data.issuer
                                                                });
                                                            });
                                                        } else if (data.message === 'NE') {
                                                            setShowCertErr(true);
                                                        }
                                                        setUploading(false);
                                                    })
                                                    .catch(() => setShowCertErr(true));
                                            }
                                        }}
                                    />
                                </div>
                            </Form.Item>
                        )}
                        {(certUploadResp || selectedUser?.dn) && (
                            <>
                                <InputComponent
                                    disabled={true}
                                    notRequired={true}
                                    label="CERTIFIKAT"
                                    name="dn"
                                    initialValue={certUploadResp?.dn || selectedUser?.dn}
                                />
                                <InputComponent
                                    disabled={true}
                                    notRequired={true}
                                    label="VYSTAVITEL_CERTIFIKATU"
                                    name="issuer"
                                    initialValue={certUploadResp?.issuer || selectedUser?.issuer}
                                />
                            </>
                        )}
                        {(certUploadResp?.pouziticert || []).length > 0 && (
                            <>
                                <Title level={5} dividerTitle={true} text="CERT_POUZITY_U" />
                                <TableComponent
                                    loading={loading}
                                    columns={[
                                        {
                                            title: <TranslateText>UZIVATEL</TranslateText>,
                                            dataIndex: 'uzivatel',
                                            key: 'uzivatel'
                                        },
                                        {
                                            title: <TranslateText>PROFIL</TranslateText>,
                                            dataIndex: 'profil',
                                            key: 'profil'
                                        },
                                        {
                                            title: <TranslateText>ID_SUBJEKTU</TranslateText>,
                                            dataIndex: 'idsubjektu',
                                            key: 'idsubjektu'
                                        },
                                        {
                                            title: <TranslateText>SUBJEKT</TranslateText>,
                                            dataIndex: 'subjekt',
                                            key: 'subjekt'
                                        }
                                    ]}
                                    rowKey={record => record.idsubjektu}
                                    dataSource={certUploadResp?.pouziticert}
                                    locale={{
                                        emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                                    }}
                                    pagination={false}
                                />
                            </>
                        )}
                        <Row className="button-row">
                            {selectedUser && (
                                <>
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        onClick={() => setSelectedUser && setSelectedUser(undefined)}
                                        type="default"
                                        id="uzivatelZpetBtn"
                                    />

                                    {!isEdit && (
                                        <ButtonComponent
                                            buttontext="BUTTON_UPRAVIT"
                                            onClick={() => setIsEdit(true)}
                                            id="uzivatelUpravitBtn"
                                        />
                                    )}
                                </>
                            )}
                            {(!selectedUser || isEdit) && (
                                <ButtonComponent
                                    buttontext="ULOZIT"
                                    onClick={() => form.submit()}
                                    id="uzivatelUlozitBtn"
                                    extramessage={err}
                                />
                            )}
                        </Row>
                    </>
                </FormWrapper>
            </>
        </LoadingWrapper>
    );
};

export default Uzivatel;

export const UzivatelPage: React.FC = () => {
    return <Uzivatel />;
};
